"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var idm_reporting_service_client_js_1 = require("@synisys/idm-reporting-service-client-js");
var report_view_styles_1 = require("../../common/model/style/report-view-styles");
var idm_report_export_service_client_js_1 = require("@synisys/idm-report-export-service-client-js");
var idm_report_export_service_client_js_2 = require("@synisys/idm-report-export-service-client-js");
/**
 * ReportTableView to {@code ReportViewStyles} parser
 */
var ReportViewStylesParser = /** @class */ (function () {
    function ReportViewStylesParser() {
    }
    ReportViewStylesParser.parse = function (tableView) {
        var reportViewStyles = new report_view_styles_1.ReportViewStyles();
        reportViewStyles.rowBranchStylesDto = [];
        reportViewStyles.columnBranchStylesDto = [];
        var rowsRootView = tableView.rows;
        var lastBranchIndex = 0;
        for (var i = 0; i < rowsRootView.rows.length; i++) {
            var rowView = rowsRootView.rows[i];
            if (rowView.isRemoved) {
                continue;
            }
            lastBranchIndex = this.parseRowView(rowView, lastBranchIndex, reportViewStyles);
            lastBranchIndex++;
        }
        var columns = tableView.columns;
        lastBranchIndex = 0;
        for (var i = 0; i < columns.children.length; i++) {
            var columnView = columns.children[i];
            if (!(columnView.isNew || columnView.isDefaultNew)) {
                lastBranchIndex = this.parseColumnView(columnView, lastBranchIndex, reportViewStyles);
                lastBranchIndex++;
            }
        }
        return reportViewStyles;
    };
    ReportViewStylesParser.parseRowView = function (rowView, rowBranchIndex, reportViewStyles) {
        var element = rowView.element;
        var rowBranchStylesDto = reportViewStyles.rowBranchStylesDto[rowBranchIndex];
        if (!rowBranchStylesDto) {
            rowBranchStylesDto = new idm_report_export_service_client_js_1.RowBranchStylesDto();
            rowBranchStylesDto.branchIndex = rowBranchIndex;
            reportViewStyles.rowBranchStylesDto[rowBranchIndex] = rowBranchStylesDto;
            rowBranchStylesDto.categoriesStyle = new Map();
        }
        rowBranchStylesDto.categoriesStyle.set(rowView.element.categoryElementDto.categoryPathHolderId, rowView.rowCategoryStyleDto);
        var lastBranchIndex = rowBranchIndex;
        for (var i = 0; i < rowView.children.length; i++) {
            var row = rowView.children[i];
            lastBranchIndex = this.parseRowView(row, lastBranchIndex, reportViewStyles);
            if (i < rowView.children.length - 1) {
                lastBranchIndex++;
            }
        }
        for (var i = rowBranchIndex; i <= lastBranchIndex; ++i) {
            var branchStylesDto = reportViewStyles.rowBranchStylesDto[i];
            branchStylesDto.categoriesStyle.set(element.categoryElementDto.categoryPathHolderId, rowView.rowCategoryStyleDto);
        }
        return lastBranchIndex;
    };
    ReportViewStylesParser.parseColumnView = function (columnView, columnBranchIndex, reportViewStyles) {
        var element = columnView.element;
        var columnBranchStylesDto = reportViewStyles.columnBranchStylesDto[columnBranchIndex];
        if (!columnBranchStylesDto) {
            columnBranchStylesDto = new idm_report_export_service_client_js_2.ColumnBranchStylesDto();
            columnBranchStylesDto.branchIndex = columnBranchIndex;
            reportViewStyles.columnBranchStylesDto[columnBranchIndex] = columnBranchStylesDto;
            columnBranchStylesDto.categoriesStyle = new Map();
        }
        var lastBranchIndex = columnBranchIndex;
        for (var i = 0; i < columnView.children.length; i++) {
            var columnViewChild = columnView.children[i];
            lastBranchIndex = this.parseColumnView(columnViewChild, lastBranchIndex, reportViewStyles);
            if (i < columnView.children.length - 1) {
                lastBranchIndex++;
            }
        }
        for (var i = columnBranchIndex; i <= lastBranchIndex; ++i) {
            var branchStylesDto = reportViewStyles.columnBranchStylesDto[i];
            if (element instanceof idm_reporting_service_client_js_1.ColumnCategoryDto) {
                var columnCategoryDto = element;
                branchStylesDto.categoriesStyle.set(columnCategoryDto.categoryElementDto.categoryPathHolderId, columnView.columnStyleDto);
            }
            else {
                branchStylesDto.measureStyle = columnView.columnStyleDto;
            }
        }
        return lastBranchIndex;
    };
    return ReportViewStylesParser;
}());
exports.ReportViewStylesParser = ReportViewStylesParser;
//# sourceMappingURL=report-view-styles.parser.js.map